import { render } from "./AppPercentage.vue?vue&type=template&id=61019bbb"
import script from "./AppPercentage.vue?vue&type=script&lang=js"
export * from "./AppPercentage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__